import axios from "axios";
import { getToken } from "./AuthService";

export const BASE_URL = process.env.REACT_APP_BACKEND_HOST;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

export const setHeaders = (token) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + token;
};

export const get = (url, params) => {
  axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + getToken();
  return axiosInstance.get(url, params);
};

export const post = (url, params) => {
  return axiosInstance.post(url, params);
};

export const del = (url) => {
  return axiosInstance.delete(url);
};

export const put = (url, params) => {
  return axiosInstance.put(url, params);
};

export const patch = (url, params) => {
  return axiosInstance.patch(url, params);
};
